const ISTANBUL_TIME_ZONE = 'Europe/Istanbul';

const getIstanbulParts = (date = new Date()) => {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: ISTANBUL_TIME_ZONE,
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).formatToParts(date);

  return Object.fromEntries(parts.map(({ type, value }) => [type, value]));
};

export const isIstanbulMarketOpen = (date = new Date()) => {
  const { weekday, hour, minute } = getIstanbulParts(date);
  const minutes = Number(hour) * 60 + Number(minute);
  return !['Sat', 'Sun'].includes(weekday) && minutes >= 9 * 60 && minutes < 18 * 60;
};

export const isCurrencyStale = (currency, date = new Date()) => {
  if (!currency?.fetchedAt) return true;
  if (currency.source !== 'TRUNCGIL' || !isIstanbulMarketOpen(date)) return false;
  const fetchedAt = new Date(currency.fetchedAt).getTime();
  if (!Number.isFinite(fetchedAt)) return true;
  return date.getTime() - fetchedAt > 15 * 60 * 1000;
};

export const formatSourceUpdate = (currency) => {
  if (!currency) return 'Veri yok';
  if (currency.sourceUpdatedAt) return String(currency.sourceUpdatedAt);
  if (!currency.fetchedAt) return 'Veri yok';
  return new Date(currency.fetchedAt).toLocaleString('tr-TR', {
    timeZone: ISTANBUL_TIME_ZONE,
    dateStyle: 'short',
    timeStyle: 'short'
  });
};
